'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const LeftHandNavigationHeader = renderWithRef('LeftHandNavigationHeader', null, (a, o)=>jsx(RenderComp, {
        root: "h2",
        forwardedRef: o,
        classNames: [
            'swan-lhn-header'
        ],
        props: a,
        children: a.children
    }));

export { LeftHandNavigationHeader };
